import { isEmpty } from 'lodash';
import React from 'react';

import styles from './cookieDetails.scss';

interface CookieDetailsProps {
  cookiesInfo: any[];
  cookieInfoLabels: Record<string, any>;
  cookieDetailsLabel?: string;
}

const CookieDetails = ({
  cookiesInfo,
  cookieInfoLabels,
  cookieDetailsLabel = 'Cookie details'
}: CookieDetailsProps) => {
  const cookieAttributes = [
    {
      label: cookieInfoLabels.nameText,
      key: 'name'
    },
    {
      label: cookieInfoLabels.providerText,
      key: 'provider'
    },
    {
      label: cookieInfoLabels.purposeText,
      key: 'purpose'
    },
    {
      label: cookieInfoLabels.durationText,
      key: 'duration'
    },
    {
      label: cookieInfoLabels.typeText,
      key: 'type'
    }
  ];

  const getCookieInformation = (cookie) =>
    cookieAttributes.map(
      (info, index) =>
        // eslint-disable-next-line react/no-array-index-key
        !isEmpty(cookie[info.key]) && (
          <div className={styles.row} key={index}>
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: `${info.label}:` }} />
            <div className={styles.info} dangerouslySetInnerHTML={{ __html: cookie[info.key] }} />
          </div>
        )
    );

  return (
    <div
      className={styles.detailsWrapper}
      tabIndex={0}
      role="region"
      aria-label={cookieDetailsLabel}
    >
      {Object.values(cookiesInfo).map((cookie, index) => (
        // eslint-disable-next-line react/no-array-index-key
        (<div className={styles.details} key={index}>
          {getCookieInformation(cookie)}
        </div>)
      ))}
    </div>
  );
};

export default CookieDetails;
